import TIML from '../../../framework/timl.js';
import { ShowPage } from '../crud/shared.js';

class SupportDetails {
  static timl = `
    table.details-table
      tbody
        tr
          th Subject
          td {{ item.subject }}
        tr
          th Message
          td {{ item.message }}
        tr
          th Status
          td {{ item.status }}
        tr
          th Priority
          td {{ item.priority }}
        tr
          th Account ID
          td {{ item.accountId }}
        tr
          th Created At
          td {{ item.createdAt }}
        tr
          th Updated At
          td {{ item.updatedAt }}
        tr
          th Created By
          td {{ item.createdBy }}
        tr
          th Updated By
          td {{ item.updatedBy }}
  `;
}

export class SupportShow extends ShowPage {
  static timl = `
    a#share-button.list-view-add-button.float-right[href="/support/{{ Routing.params.id }}/edit"] Edit
    <Breadcrumbs title="Support" href="/support" nameHref="/support/{{ Routing.params.id }}" nameStyle="" nameSeparatorStyle="" suffix="" suffixStyle="display:none;" suffixSeparatorStyle="display:none;">
    div#support-details.mt-15 Loading...
  `;

  static mapItemToViewModel(item) {
    return {
      item: {
        subject: item.subject || '—',
        message: item.message || '—',
        status: item.status || '—',
        priority: item.priority || '—',
        accountId: item.accountId || '—',
        createdAt: Util.formatDate(item.createdAt) || '—',
        updatedAt: Util.formatDate(item.updatedAt) || '—',
        createdBy: item.createdBy || '—',
        updatedBy: item.updatedBy || '—'
      }
    };
  }

  static javascript() {
    super.javascript();

    API.get(API.resourceUrl('support', Routing.params.id))
      .then(data => {
        const viewModel = this.mapItemToViewModel(data.data);
        document.querySelector('#name').innerText = viewModel.item.subject;
        TIML.renderInto(document.querySelector('#support-details'), SupportDetails, viewModel);
      });
  }
}
